/**
 * Spinner Component used in SCI
 * To Be swapped by GlobalSpinner
 */

import { Spinner } from '@makemydeal/ui-bricks/dist/cox';
import { SpinnerContainer } from './SalesCheckInSpinner.style';

// spinner component used to show loading state
const SalesCheckInSpinner = () => {
    return (
        <SpinnerContainer data-testid="sales-checkin-spinner">
            <Spinner />
        </SpinnerContainer>
    );
};

export default SalesCheckInSpinner;
